/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
//BS CUSTOM - everything
import * as React from 'react';
import { ITrustpilotWidgetProps } from './trustpilot-widget.props.autogenerated';
import { ITrustpilotWidgetData } from './trustpilot-widget.data';

export interface ITrustpilotWidgetViewProps extends ITrustpilotWidgetProps<ITrustpilotWidgetData> {
    ref: React.RefObject<HTMLDivElement>;
    businessUnitId: string;
    widgetType: string;
    widgetConfig: {
        widgetId: string;
        businessUnitId: string;
        trustPilotLink: string;
        templateId?: string;
        height?: string;
        width?: string;
        tags?: string;
        dataLocale?: string;
        reviewLanguages?: string;
    };
}

export default (props: ITrustpilotWidgetViewProps) => {
    const { widgetConfig, ref } = props;

    return (
        <div
            ref={ref}
            className='trustpilot-widget'
            id={`trustbox_${widgetConfig.widgetId}`}
            data-locale={widgetConfig.dataLocale}
            data-template-id={widgetConfig.templateId}
            data-businessunit-id={widgetConfig.businessUnitId}
            data-style-height={widgetConfig.height}
            data-style-width={widgetConfig.width}
            data-tags={widgetConfig.tags}
            data-review-languages={widgetConfig.reviewLanguages}
        >
            <a href={widgetConfig.trustPilotLink} target='_blank' rel='noopener noreferrer'>
                {' '}
                Trustpilot
            </a>
        </div>
    );
};
